import React, { useEffect } from 'react';
import PowertrainConfigurationComponent from './PowertrainConfigurationComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import './style.scss';


const PowertrainConfigurationContainer = (props) => {
    const {
        generalFilterLoadingStatuses,
    } = props.model;

    useEffect(() => {
        return () => {
            props.actions.clearStore();
        };
    }, []);

    return <LoadingStatusWrapper
        loadingStatus={[...generalFilterLoadingStatuses]}>
        <PowertrainConfigurationComponent {...props} />
    </LoadingStatusWrapper >;
};


const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const PowertrainConfigurationContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(PowertrainConfigurationContainer);

export default PowertrainConfigurationContainerConn;
